import { render } from "./dzPage.vue?vue&type=template&id=69a7c950&scoped=true"
import script from "./dzPage.vue?vue&type=script&lang=js"
export * from "./dzPage.vue?vue&type=script&lang=js"

import "./dzPage.vue?vue&type=style&index=0&id=69a7c950&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a7c950"]])

export default __exports__